module.exports = __webpack_public_path__ + "static/media/9.617ab895.jpg";